/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Saving_ProjectInputs */

const en_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving Project`)
};

const fr_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement du projet`)
};

const de_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparprojekt`)
};

const it_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio del progetto`)
};

const ru_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект спасения`)
};

const es_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto de ahorro`)
};

const zh_cn2_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`储蓄项目`)
};

const ja_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存プロジェクト`)
};

const hi_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचत परियोजना`)
};

const pt_pt2_iconik_publish_status_saving_project = /** @type {(inputs: Iconik_Publish_Status_Saving_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto de economia`)
};

/**
* | output |
* | --- |
* | "Saving Project" |
*
* @param {Iconik_Publish_Status_Saving_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_saving_project = /** @type {((inputs?: Iconik_Publish_Status_Saving_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Saving_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_status_saving_project(inputs)
	if (locale === "de") return de_iconik_publish_status_saving_project(inputs)
	if (locale === "it") return it_iconik_publish_status_saving_project(inputs)
	if (locale === "ru") return ru_iconik_publish_status_saving_project(inputs)
	if (locale === "es") return es_iconik_publish_status_saving_project(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_status_saving_project(inputs)
	if (locale === "ja") return ja_iconik_publish_status_saving_project(inputs)
	if (locale === "hi") return hi_iconik_publish_status_saving_project(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_status_saving_project(inputs)
	return en_iconik_publish_status_saving_project(inputs)
});